









import { Vue, Component, Prop } from "@/shared/vuepack";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import { PlanSetting } from "@/shared/types";
import { formatPlansDateString } from "@/employer/utilities/myPlansFormatter";

@Component({
  components: { CommonTab }
})
export default class PlanTab extends Vue {
  @Prop()
  title: string;
  @Prop()
  plans: PlanSetting[];
  formatPlansDateString = formatPlansDateString;
}
